import { render, staticRenderFns } from "./ConfigureFastAppointment.vue?vue&type=template&id=56e7c4ee&scoped=true&"
import script from "./ConfigureFastAppointment.vue?vue&type=script&lang=js&"
export * from "./ConfigureFastAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureFastAppointment.vue?vue&type=style&index=0&id=56e7c4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7c4ee",
  null
  
)

export default component.exports